<template>
  <div>
  <RemotePaginatedList :headers="headers"
                       data-url="oauth2/authorized_applications/"
                       data-key="authorized_applications"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs">
    <template v-slot:item.actions="{item}">
      <v-btn icon color="primary"
             @click="prepareRevokeApplication(item)">
        <v-icon>fas fa-trash</v-icon>
      </v-btn>
    </template>
    <template v-slot:item.latest_create_at="{value}">
      {{ $parseDate(value, 'yyyy-MM-dd HH:mm:ss') }}
    </template>
  </RemotePaginatedList>
    <v-dialog v-model="confirmDialogShown"
              content-class="confirm-dialog"
              max-width="330"
              persistent
              scrollable>
      <v-card>
        <v-card-title>{{ $t('authorized_application.revoke_title') }}</v-card-title>
        <v-card-text>{{ $t('authorized_application.revoke_confirm_msg') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text
                 @click="confirmDialogShown = false">
            {{ $t('no') }}
          </v-btn>
          <v-btn text
                 color="rgb(142, 118, 91)"
                 @click="revokeApplication">
            {{ $t('yes') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {onMounted, ref, watch} from "@vue/composition-api";
import RemotePaginatedList from "@/components/RemotePaginatedList";

export default {
  name: 'OauthAuthorizedApplicationsList',
  components: {RemotePaginatedList},
  setup(props, {root, emit}) {
    const confirmDialogShown = ref(false);
    const currentItem = ref(null);
    const innerRefreshTrigger = ref(false);
    const refresh = async function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    });

    // Data Table
    const headers = ref([
      {text: root.$t('my_account.authorized_applications'), value: root.$t('oauth.application_name')},
      {text: root.$t('my_account.authorized_applications_latest_create_at'), value: 'latest_create_at'},
      {text: '', value: 'actions', sortable: false},
    ]);

    const prepareRevokeApplication = function (item) {
        currentItem.value = item;
        confirmDialogShown.value = true;
    }

    const revokeApplication = function () {
        root.$callAPI(`oauth2/authorized_application/revoke/`, {
          application_id : currentItem.value.application
        }, () => {
          confirmDialogShown.value = false;
          refresh();
        })
    };

    return {
      innerRefreshTrigger,
      confirmDialogShown,
      headers,

      revokeApplication,
      prepareRevokeApplication
    }
  },
}
</script>

<style lang="less">
.b-table-empty-row {
  color: #444;
  font-size: 2rem;
}

</style>
